
export enum ImageVariant {
    /** 640x500 */
    PICTURE_LARGE = 'large',
    /** 300x300 */
    PICTURE_MEDIUM = 'medium',
    /** 150x150 */
    PICTURE_SMALL = 'small',
    /** 48x48 */
    PICTURE_CONTACT_FINDER = 'contact-finder',
    /** 75x100 */
    PICTURE_CONTACT_THUMBNAIL = 'contact-thumbnail',
}

export enum ThumbnailPreset {
    CONTACT_THUMB = 'contact_thumb',    // 150x150
    GALLERY_THUMB = 'gallery_thumb',    // 300x300
    MID_PREVIEW = 'mid_preview',        // 800x600
    FULL_PREVIEW = 'full_preview',      // 1280x960
    BANNER_THUMB = 'banner_thumb',      // 1024x512
    SQUARE_THUMB = 'square_thumb',      // 500x500
    DOCUMENT_THUMB = 'document_thumb',  // 200x260
}
const URL_MOORING  = '/mooring/documentThumbnail/';

export const getImagePath = (docId: string, variant: ImageVariant = ImageVariant.PICTURE_LARGE, base_url:string, server:string, session:string): string => {
    if(!docId) return '';
    return `${base_url}${URL_MOORING}${variant}?server=${server}&session=${session}&id=${docId}`;
};

export const getDownloadUrl = (docId: string, base_url:string, server:string, session:string): string => {
    if(!docId) return '';
    return `${base_url}/asp-cgi/doc-download.cgi?instance=${server}&session=${session}&documentId=${docId}&disposition=inline`;
};

export const getThumbnail = async (docId: string, preset: ThumbnailPreset, base_url: string, thumbnail_url: string, server: string, session: string): Promise<Blob> => {
    if (!docId) throw new Error('Document ID is required');
    
    const axios = (await import('axios')).default;
    
    const url = `${thumbnail_url}?preset=${preset}&document_id=${docId}`;
    
    const response = await axios.get(url, {
        headers: {
            'X-Atollon-Url': base_url,
            'X-Atollon-Session': session,
            'X-Atollon-Server': server,
        },
        responseType: 'blob',
    });
    
    return response.data;
};

export const blobToBase64Image = async (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject(new Error('Failed to convert blob to base64'));
            }
        };
        reader.onerror = () => {
            reject(new Error('Error reading blob'));
        };
        reader.readAsDataURL(blob);
    });
};
